import * as React from 'react';
import { useSelector } from 'react-redux';
import { BookingInfo } from 'shared/components/BookingInfo';
import { selectDailyrentBookingGeneral, selectPaymentSummaryWithDiscount } from 'shared/selectors/dailyrentBooking';

export const BookingSummaryContainer: React.FC = () => {
  const { isLoading } = useSelector(selectDailyrentBookingGeneral);
  const paymentSummaryWithDiscount = useSelector(selectPaymentSummaryWithDiscount);

  if (!paymentSummaryWithDiscount) {
    return null;
  }

  return <BookingInfo paymentSummary={paymentSummaryWithDiscount} isLoading={isLoading} />;
};
